import axios from "@/libs/api.request";
// 获取成本科目
export const getList = (params) => {
  return axios.request({
    url: "/cost/classify/index",
    method: "GET",
    params,
  });
};
// 添加成本科目
export const add = (data) => {
  return axios.request({
    url: `/cost/classify/save/${data.id}`,
    method: "POST",
    data,
  });
};

// 编辑成本科目
export const update = (data) => {
  return axios.request({
    url: `/cost/classify/update/${data.id}`,
    method: "POST",
    data,
  });
};

// 删除成本科目
export const del = (id) => {
  return axios.request({
    url: `/cost/classify/delete/${id}`,
    method: "POST",
  });
};
